"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Check } from "lucide-react";
import type { CampaignPageSection } from "@growwithai/shared";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type PricingTableProps = Extract<CampaignPageSection, {
  type: "pricing_table";
}>;

/** Tabel harga statis buatan admin (beda dari 'pricing' yang menarik plan live). */
export default function PricingTableSection(t0) {
  const $ = _c(20);
  const {
    section
  } = t0;
  if (section.tiers.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style) {
    t2 = sectionHeadingStyle(section.custom_style);
    $[2] = section.custom_style;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== section.heading || $[5] !== t2) {
    t3 = <h2 className="text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={t2}>{section.heading}</h2>;
    $[4] = section.heading;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== section.subheading) {
    t4 = section.subheading && <p className="mx-auto mt-2 max-w-xl text-center text-sm text-warm-black/70">{section.subheading}</p>;
    $[7] = section.subheading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== section.tiers) {
    t5 = section.tiers.map(_temp2);
    $[9] = section.tiers;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{t5}</div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t6) {
    t7 = <div className="mx-auto max-w-5xl px-5">{t3}{t4}{t6}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t7) {
    t8 = <section className="bg-warm-cream py-14 md:py-20" style={t1}>{t7}</section>;
    $[17] = t1;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp2(tier, i) {
  return <div key={i} className={`relative flex flex-col rounded-2xl border bg-white p-6 shadow-[var(--card-shadow,none)] [backdrop-filter:var(--card-backdrop,none)] ${tier.highlighted ? "border-[var(--brand-primary)] ring-2 ring-[var(--brand-primary)]/20" : "[border-color:var(--card-border-color,rgba(0,0,0,.08))]"}`}>{tier.highlighted && <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[var(--brand-primary)] px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-[var(--brand-on-primary,#fff)]">Populer</span>}<h3 className="text-lg font-bold text-warm-black">{tier.name}</h3><div className="mt-2 flex items-baseline gap-1"><span className="text-3xl font-black text-warm-black">{tier.price_label}</span>{tier.period_label && <span className="text-sm text-warm-black/60">/{tier.period_label}</span>}</div><ul className="mt-5 flex-1 space-y-2.5">{tier.features.map(_temp)}</ul><Link href={tier.cta.href} className={`mt-6 inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-semibold transition ${tier.highlighted ? "bg-[var(--brand-primary)] text-[var(--brand-on-primary,#fff)] hover:opacity-90" : "border border-[var(--brand-primary)] text-[var(--brand-primary)] hover:bg-[var(--brand-primary)]/5"}`}>{tier.cta.label}</Link></div>;
}
function _temp(f, j) {
  return <li key={j} className="flex items-start gap-2 text-sm text-warm-black/80"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[var(--brand-primary)]" /><span>{f}</span></li>;
}